// ==========================================================================
// THÈME BOUTIQUE - Global JavaScript
// ==========================================================================

document.addEventListener('DOMContentLoaded', function () {

  // ----------------------------------------------------------------------
  // MOBILE MENU
  // ----------------------------------------------------------------------
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  const menuToggles = document.querySelectorAll('[data-mobile-toggle]');
  const menuCloses = document.querySelectorAll('[data-mobile-close]');

  function openMobileMenu() {
    if (mobileMenu) mobileMenu.classList.add('is-open');
    if (mobileOverlay) mobileOverlay.classList.add('is-visible');
    document.body.classList.add('menu-open');
  }

  function closeMobileMenu() {
    if (mobileMenu) mobileMenu.classList.remove('is-open');
    if (mobileOverlay) mobileOverlay.classList.remove('is-visible');
    document.body.classList.remove('menu-open');
  }

  menuToggles.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openMobileMenu();
    });
  });

  menuCloses.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeMobileMenu();
    });
  });

  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', closeMobileMenu);
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMobileMenu();
  });

  document.querySelectorAll('.mobile-menu__nav a').forEach(link => {
    link.addEventListener('click', () => {
      setTimeout(closeMobileMenu, 100);
    });
  });

  // ----------------------------------------------------------------------
  // QUANTITY INPUT avec mise à jour panier en temps réel
  // ----------------------------------------------------------------------
  document.querySelectorAll('.quantity-input').forEach(wrapper => {
    const input = wrapper.querySelector('input');
    const btnMinus = wrapper.querySelector('[data-qty-minus]');
    const btnPlus = wrapper.querySelector('[data-qty-plus]');

    const triggerUpdate = () => {
      input.dispatchEvent(new Event('change', { bubbles: true }));
      const cartItem = wrapper.closest('.cart-item');
      if (cartItem) updateCartItem(cartItem, parseInt(input.value, 10));
    };

    if (btnMinus) {
      btnMinus.addEventListener('click', () => {
        const val = parseInt(input.value, 10);
        if (val > 0) input.value = val - 1;
        triggerUpdate();
      });
    }
    if (btnPlus) {
      btnPlus.addEventListener('click', () => {
        const val = parseInt(input.value, 10);
        input.value = val + 1;
        triggerUpdate();
      });
    }
    if (input) {
      input.addEventListener('change', () => {
        const cartItem = input.closest('.cart-item');
        if (cartItem) updateCartItem(cartItem, parseInt(input.value, 10));
      });
    }
  });

  async function updateCartItem(cartItem, quantity) {
    const allItems = Array.from(document.querySelectorAll('.cart-item'));
    const lineIndex = allItems.indexOf(cartItem) + 1;

    cartItem.style.opacity = '0.5';
    cartItem.style.pointerEvents = 'none';

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: quantity })
      });
      const cart = await response.json();

      if (quantity === 0) {
        cartItem.style.transition = 'all 0.3s';
        cartItem.style.transform = 'translateX(-20px)';
        cartItem.style.opacity = '0';
        setTimeout(() => cartItem.remove(), 300);
      } else {
        cartItem.style.opacity = '1';
        cartItem.style.pointerEvents = '';
      }

      updateCartTotals(cart);

      if (cart.item_count === 0) {
        setTimeout(() => location.reload(), 400);
      }
    } catch (err) {
      console.error(err);
      cartItem.style.opacity = '1';
      cartItem.style.pointerEvents = '';
    }
  }

  function updateCartTotals(cart) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
    });

    const summary = document.querySelector('.cart-summary');
    if (summary) {
      const subtotalRow = summary.querySelector('.cart-summary__row span:last-child');
      if (subtotalRow) subtotalRow.textContent = formatMoney(cart.items_subtotal_price);

      const totalEl = summary.querySelector('.cart-summary__total span:last-child');
      if (totalEl) {
        totalEl.textContent = formatMoney(cart.items_subtotal_price);
        totalEl.style.transition = 'color 0.3s';
        totalEl.style.color = 'var(--color-accent)';
        setTimeout(() => { totalEl.style.color = ''; }, 600);
      }
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR'
    });
  }

// ----------------------------------------------------------------------
// PRODUCT GALLERY (avec support vidéo - garde tous les médias en mémoire)
// ----------------------------------------------------------------------
(function() {
  const galleryThumbs = document.querySelectorAll('.product-gallery__thumb');
  const galleryMain = document.querySelector('[data-gallery-main]');
  
  if (!galleryMain || galleryThumbs.length === 0) return;
  
  // 🎯 Stocker le HTML original de chaque média (récupéré au chargement)
  // On va construire le HTML de chaque média à partir des miniatures
  const mediaCache = {};
  
  // Récupérer le HTML actuel de la galerie principale (le 1er média)
  const initialMedia = galleryMain.querySelector('[data-media-id]');
  if (initialMedia) {
    mediaCache[initialMedia.dataset.mediaId] = galleryMain.innerHTML;
  }
  
  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', async () => {
      const mediaId = thumb.dataset.mediaId;
      const mediaType = thumb.dataset.mediaType || 'image';
      
      if (!mediaId) return;
      
      // Marquer la miniature active
      galleryThumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      
      // Stopper toutes les vidéos en cours
      galleryMain.querySelectorAll('video').forEach(v => v.pause());
      // Vider les iframes (vidéos externes type YouTube)
      galleryMain.querySelectorAll('iframe').forEach(iframe => {
        const src = iframe.src;
        iframe.src = '';
        iframe.src = src;
      });
      
      // Si on a déjà ce média en cache, on le réutilise
      if (mediaCache[mediaId]) {
        galleryMain.innerHTML = mediaCache[mediaId];
        return;
      }
      
      // Sinon, on construit le média depuis les infos disponibles
      const thumbImg = thumb.querySelector('img');
      const fullSrc = thumbImg.dataset.full || thumbImg.src.replace(/width=\d+/, 'width=800');
      const alt = thumbImg.alt || '';
      
      let html = '';
      
      if (mediaType === 'image') {
        html = `<img src="${fullSrc}" alt="${alt}" data-media-id="${mediaId}" width="800" height="800">`;
      } else if (mediaType === 'video') {
        // On va chercher la vraie source de la vidéo via fetch du produit en JSON
        html = `<img src="${fullSrc}" alt="${alt}" data-media-id="${mediaId}">`;
        // Note: pour les vidéos non chargées, on garde juste le poster - 
        // dans Shopify les vidéos sont normalement rendues au chargement
      } else if (mediaType === 'external_video') {
        html = `<img src="${fullSrc}" alt="${alt}" data-media-id="${mediaId}">`;
      }
      
      // Mettre en cache pour réutilisation
      mediaCache[mediaId] = html;
      galleryMain.innerHTML = html;
    });
  });
})();
  // ----------------------------------------------------------------------
  // CART DRAWER
  // ----------------------------------------------------------------------
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartDrawerOverlay = document.querySelector('[data-cart-drawer-overlay]');

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartDrawerOverlay) cartDrawerOverlay.classList.add('is-visible');
    document.body.classList.add('menu-open');
  }

  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartDrawerOverlay) cartDrawerOverlay.classList.remove('is-visible');
    document.body.classList.remove('menu-open');
  }

  document.querySelectorAll('[data-cart-drawer-open]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      if (window.location.pathname === '/cart') return;
      e.preventDefault();
      openCartDrawer();
    });
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeCartDrawer();
    }
  });
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);

  function rebuildDrawerFromCart(cart) {
    const body = document.querySelector('[data-cart-drawer-body]');
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!body || !drawer) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="opacity: 0.3; margin: 0 auto 1rem;">
            <circle cx="9" cy="21" r="1"/>
            <circle cx="20" cy="21" r="1"/>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
          </svg>
          <p>Votre panier est vide</p>
          <a href="/collections/all" class="btn btn--primary" data-cart-drawer-close>Découvrir la boutique</a>
        </div>
      `;
      const footer = drawer.querySelector('.cart-drawer__footer');
      if (footer) footer.remove();
      return;
    }

    const itemsHtml = cart.items.map((item, i) => `
      <div class="cart-drawer-item" data-line="${i + 1}" data-key="${item.key}">
        <a href="${item.url}" class="cart-drawer-item__image">
          ${item.image ? `<img src="${item.image}" alt="${item.title}">` : ''}
        </a>
        <div class="cart-drawer-item__info">
          <a href="${item.url}" class="cart-drawer-item__title">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer-item__variant">${item.variant_title}</p>` : ''}
          <div class="cart-drawer-item__bottom">
            <div class="quantity-input quantity-input--small">
              <button type="button" data-qty-minus aria-label="Diminuer">−</button>
              <input type="number" value="${item.quantity}" min="0" data-line="${i + 1}">
              <button type="button" data-qty-plus aria-label="Augmenter">+</button>
            </div>
            <div class="cart-drawer-item__price">${formatMoney(item.final_price)}</div>
          </div>
          <button type="button" class="cart-drawer-item__remove" data-cart-remove data-line="${i + 1}">Retirer</button>
        </div>
      </div>
    `).join('');

    body.innerHTML = itemsHtml;

    let footer = drawer.querySelector('.cart-drawer__footer');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'cart-drawer__footer';
      drawer.appendChild(footer);
    }
    footer.innerHTML = `
      <div class="cart-drawer__subtotal">
        <span>Sous-total</span>
        <span data-cart-subtotal>${formatMoney(cart.items_subtotal_price)}</span>
      </div>
      <p class="cart-drawer__note">Livraison et taxes calculées au paiement.</p>
      <a href="/cart/checkout" class="btn btn--primary btn--full btn--large">Passer la commande</a>
      <a href="/cart" class="btn btn--ghost btn--full">Voir le panier complet</a>
    `;

    bindDrawerQuantityEvents();
  }

  function bindDrawerQuantityEvents() {
    document.querySelectorAll('.cart-drawer-item .quantity-input').forEach(wrapper => {
      const input = wrapper.querySelector('input');
      const btnMinus = wrapper.querySelector('[data-qty-minus]');
      const btnPlus = wrapper.querySelector('[data-qty-plus]');
      const line = parseInt(input.dataset.line, 10);

      btnMinus?.addEventListener('click', () => {
        const val = parseInt(input.value, 10);
        changeDrawerLine(line, val - 1);
      });
      btnPlus?.addEventListener('click', () => {
        const val = parseInt(input.value, 10);
        changeDrawerLine(line, val + 1);
      });
    });

    document.querySelectorAll('[data-cart-remove]').forEach(btn => {
      btn.addEventListener('click', () => {
        const line = parseInt(btn.dataset.line, 10);
        changeDrawerLine(line, 0);
      });
    });
  }

  async function changeDrawerLine(line, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      const cart = await (await fetch('/cart.js')).json();
      rebuildDrawerFromCart(cart);
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (err) {
      console.error(err);
    }
  }

  bindDrawerQuantityEvents();

  // 🌍 Exposer ces fonctions au window pour que la modal variantes puisse les appeler
  window.openCartDrawer = openCartDrawer;
  window.rebuildDrawerFromCart = rebuildDrawerFromCart;

  // ----------------------------------------------------------------------
  // ADD TO CART (AJAX) avec animation + ouverture drawer
  // ----------------------------------------------------------------------
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn ? btn.innerHTML : '';
      if (btn) {
        btn.innerHTML = '<span class="btn-spinner"></span> Ajout...';
        btn.disabled = true;
      }

      const productImage = document.querySelector('.product-gallery__main img')
        || form.closest('.product-card')?.querySelector('.product-card__image');
      const cartIcon = document.querySelector('.header-icon[aria-label="Panier"]');
      if (cartIcon) flyToCart(productImage, cartIcon);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form)
        });

        if (response.ok) {
          const cart = await (await fetch('/cart.js')).json();
          document.querySelectorAll('.cart-count').forEach(el => {
            el.textContent = cart.item_count;
            el.classList.remove('cart-count--bounce');
            void el.offsetWidth;
            el.classList.add('cart-count--bounce');
          });
          if (cartIcon) {
            cartIcon.classList.add('header-icon--pulse');
            setTimeout(() => cartIcon.classList.remove('header-icon--pulse'), 600);
          }
          if (btn) {
            btn.innerHTML = '✓ Ajouté !';
            btn.classList.add('btn--success');
          }
          setTimeout(() => {
            if (btn) {
              btn.innerHTML = originalText;
              btn.disabled = false;
              btn.classList.remove('btn--success');
            }
            rebuildDrawerFromCart(cart);
            openCartDrawer();
          }, 900);
        } else {
          if (btn) {
            btn.innerHTML = 'Erreur';
            btn.disabled = false;
          }
        }
      } catch (err) {
        console.error(err);
        if (btn) {
          btn.innerHTML = originalText;
          btn.disabled = false;
        }
      }
    });
  });

  function flyToCart(fromEl, toEl) {
    const toRect = toEl.getBoundingClientRect();
    let clone;

    if (fromEl && fromEl.tagName === 'IMG' && fromEl.src) {
      const fromRect = fromEl.getBoundingClientRect();
      clone = fromEl.cloneNode(true);
      clone.style.cssText = `
        position: fixed;
        top: ${fromRect.top}px;
        left: ${fromRect.left}px;
        width: ${fromRect.width}px;
        height: ${fromRect.height}px;
        object-fit: cover;
        border-radius: 50%;
        z-index: 9999;
        pointer-events: none;
        transition: all 0.8s cubic-bezier(0.55, 0, 0.6, 1);
        box-shadow: 0 8px 24px rgba(0, 39, 152, 0.3);
      `;
    } else {
      const startX = window.innerWidth / 2;
      const startY = window.innerHeight / 2;
      clone = document.createElement('div');
      clone.innerHTML = `
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="9" cy="21" r="1"/>
          <circle cx="20" cy="21" r="1"/>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
        </svg>
      `;
      clone.style.cssText = `
        position: fixed;
        top: ${startY}px;
        left: ${startX}px;
        width: 80px;
        height: 80px;
        background: #FF7F00;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        pointer-events: none;
        transition: all 0.8s cubic-bezier(0.55, 0, 0.6, 1);
        box-shadow: 0 8px 24px rgba(255, 127, 0, 0.5);
        transform: translate(-50%, -50%);
      `;
    }

    document.body.appendChild(clone);
    requestAnimationFrame(() => {
      clone.style.top = toRect.top + 'px';
      clone.style.left = toRect.left + 'px';
      clone.style.width = '40px';
      clone.style.height = '40px';
      clone.style.opacity = '0.3';
      clone.style.transform = 'rotate(360deg)';
    });
    setTimeout(() => clone.remove(), 850);
  }

  // ----------------------------------------------------------------------
  // COUNTDOWN
  // ----------------------------------------------------------------------
  document.querySelectorAll('[data-countdown]').forEach(el => {
    const targetDate = new Date(el.dataset.countdown).getTime();
    if (isNaN(targetDate)) return;

    const update = () => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        el.innerHTML = '<p>Offre terminée</p>';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const d = el.querySelector('[data-days]');
      const h = el.querySelector('[data-hours]');
      const m = el.querySelector('[data-minutes]');
      const s = el.querySelector('[data-seconds]');
      if (d) d.textContent = String(days).padStart(2, '0');
      if (h) h.textContent = String(hours).padStart(2, '0');
      if (m) m.textContent = String(minutes).padStart(2, '0');
      if (s) s.textContent = String(seconds).padStart(2, '0');
    };

    update();
    setInterval(update, 1000);
  });

  // ----------------------------------------------------------------------
  // ANIMATE ON SCROLL (fade in)
  // ----------------------------------------------------------------------
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));


  // ----------------------------------------------------------------------
  // HEADER : ombre au scroll
  // ----------------------------------------------------------------------
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        siteHeader.classList.add('scrolled');
      } else {
        siteHeader.classList.remove('scrolled');
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  // ----------------------------------------------------------------------
  // ANNOUNCEMENT BAR : calcul précis pour boucle sans saut
  // ----------------------------------------------------------------------
  function setupTicker() {
    const track = document.querySelector('.announcement-bar__track');
    if (!track) return;
    
    const groups = track.querySelectorAll('.announcement-bar__group');
    if (groups.length < 2) return;
    
    const groupWidth = Math.round(groups[0].offsetWidth);
    track.style.setProperty('--ticker-distance', `-${groupWidth}px`);
  }
  
  setupTicker();
  window.addEventListener('resize', setupTicker);
});


/* ==========================================================================
   VARIANT PICKER MODAL (pour quick-add de produits à variantes)
   ========================================================================== */

(function() {
  const overlay = document.querySelector('[data-variant-picker-overlay]');
  const picker = document.querySelector('[data-variant-picker]');
  if (!picker) return;
  
  const closeBtn = picker.querySelector('[data-variant-picker-close]');
  const titleEl = picker.querySelector('[data-variant-picker-title]');
  const imageEl = picker.querySelector('[data-variant-picker-image]');
  const priceEl = picker.querySelector('[data-variant-picker-price]');
  const optionLabelEl = picker.querySelector('[data-variant-picker-option-label]');
  const sizesContainer = picker.querySelector('[data-variant-picker-sizes]');
  const addBtn = picker.querySelector('[data-variant-picker-add]');
  
  let currentVariants = [];
  let currentSelectedVariantId = null;
  
  function openPicker(triggerBtn) {
    const variantsJson = triggerBtn.dataset.productVariants;
    if (!variantsJson) return;
    
    try {
      const decoded = variantsJson
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>');
      currentVariants = JSON.parse(decoded);
    } catch(e) {
      console.error('Erreur parsing variantes:', e);
      return;
    }
    
    titleEl.textContent = triggerBtn.dataset.productTitle || '';
    imageEl.src = triggerBtn.dataset.productImage || '';
    imageEl.alt = triggerBtn.dataset.productTitle || '';
    priceEl.textContent = triggerBtn.dataset.productPrice || '';
    optionLabelEl.textContent = triggerBtn.dataset.productOptionName || 'Taille';
    
    sizesContainer.innerHTML = '';
    currentSelectedVariantId = null;
    
    currentVariants.forEach(variant => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'variant-size-btn';
      btn.textContent = variant.options[0];
      btn.dataset.variantId = variant.id;
      
      if (!variant.available) {
        btn.disabled = true;
        btn.title = 'Rupture de stock';
      }
      
      btn.addEventListener('click', () => {
        sizesContainer.querySelectorAll('.variant-size-btn').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        currentSelectedVariantId = variant.id;
        
        addBtn.disabled = false;
        
        const isPreorder = variant.inventory_management === 'shopify' 
                         && variant.inventory_quantity <= 0 
                         && variant.inventory_policy === 'continue';
        addBtn.textContent = isPreorder ? 'Pré-commander' : 'Ajouter au panier';
      });
      
      sizesContainer.appendChild(btn);
    });
    
    addBtn.disabled = true;
    addBtn.textContent = 'Choisir une taille';
    
    overlay.classList.add('is-visible');
    picker.classList.add('is-open');
    document.body.classList.add('variant-picker-open');
  }
  
  function closePicker() {
    overlay.classList.remove('is-visible');
    picker.classList.remove('is-open');
    document.body.classList.remove('variant-picker-open');
  }
  
  addBtn.addEventListener('click', async () => {
    if (!currentSelectedVariantId || addBtn.disabled) return;
    
    addBtn.disabled = true;
    const originalText = addBtn.textContent;
    addBtn.innerHTML = '<span class="btn-spinner"></span> Ajout en cours...';
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({ id: currentSelectedVariantId, quantity: 1 })
      });
      
      if (!response.ok) throw new Error('Erreur ajout');
      
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      
      document.querySelectorAll('.cart-count, [data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.remove('cart-count--bounce');
        void el.offsetWidth;
        el.classList.add('cart-count--bounce');
      });
      
      const cartIcon = document.querySelector('.header-icon[aria-label="Panier"]');
      if (cartIcon) {
        cartIcon.classList.add('header-icon--pulse');
        setTimeout(() => cartIcon.classList.remove('header-icon--pulse'), 600);
      }
      
      closePicker();
      
      // 🎯 Rebuild le drawer AVEC le nouveau contenu, PUIS l'ouvrir
      setTimeout(() => {
        if (typeof window.rebuildDrawerFromCart === 'function') {
          window.rebuildDrawerFromCart(cart);
        }
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        }
      }, 300);
      
      addBtn.disabled = false;
      addBtn.textContent = originalText;
      
    } catch(err) {
      console.error(err);
      addBtn.disabled = false;
      addBtn.textContent = originalText;
      alert('Une erreur est survenue, veuillez réessayer.');
    }
  });
  
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-variant-picker-trigger]');
    if (trigger) {
      e.preventDefault();
      openPicker(trigger);
    }
  });
  
  closeBtn.addEventListener('click', closePicker);
  overlay.addEventListener('click', closePicker);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && picker.classList.contains('is-open')) closePicker();
  });
})();


